window.addEventListener('load', (event) => {
  jdgmSettings.scrollTopOffset = 160;
  if(document.getElementsByClassName('jdgm-prev-badge')[0]) {
    document.getElementsByClassName('jdgm-prev-badge')[0].addEventListener("click", function(){
      if(window.innerWidth > 767) {
        $('.tab_wrapper .product-block-title a').eq(2)[0].click()
      }
      else {
        jdgmSettings.scrollTopOffset = 130;
        if($('.tab_wrapper .product-block-content button').eq(2).hasClass('is-open')) {} else {
          $('.tab_wrapper .product-block-content button').eq(2)[0].click()
        }    
      }
    })
  }
  if(document.getElementsByClassName('jdgm-write-rev-link')[0]) {
    document.getElementsByClassName('jdgm-write-rev-link')[0].addEventListener("click", function(){
      if(window.innerWidth > 767) {
      }
      else {
        $('.tab_wrapper .collapsible-content--all').eq(2).css('height', $('#judgeme_product_reviews').css('height'))
        setTimeout(function() {
          $('.tab_wrapper .collapsible-content--all').eq(2).css('height', $('#judgeme_product_reviews').css('height'))
        }, 1500)
      }
    })
  }
  if(document.getElementsByClassName('jdgm-ask-question-btn')[0]) {
    document.getElementsByClassName('jdgm-ask-question-btn')[0].addEventListener("click", function(){
      if(window.innerWidth > 767) {
      }
      else {
        $('.tab_wrapper .collapsible-content--all').eq(2).css('height', $('#judgeme_product_reviews').css('height'))
        setTimeout(function() {
          $('.tab_wrapper .collapsible-content--all').eq(2).css('height', $('#judgeme_product_reviews').css('height'))
        }, 1500)
      }
    })
  }
})                                                                    